// extracted by mini-css-extract-plugin
module.exports = {"back":"back_back__32OTt","arrowPart":"back_arrowPart__3ybv9"};